import React from 'react';
import { PropTypes } from 'prop-types';
import SearchForm, { TextSearchHeader } from '../searchForm';
import RadioButton from '../form/RadioButton';

const whiteGloves = [{ value: "", name: "Any" }, { value: "true", name: "Yes" }, { value: "false", name: "No" }];

const ClientSeachHeader = () => (
  <TextSearchHeader placeholder="Search by company or client name" />
);

const ClientFilter = (props) => {
  return (
    <SearchForm
      initialValues={{
        searchText: "",
        whiteGloves: ""
      }}
      searchHeader={ClientSeachHeader}
      onSubmit={props.onSearch}
      onReset={props.onClear}>
      <div className="box">
        <cite>Wihte gloves</cite>
        <RadioButton
          name="whiteGloves"
          vertical={true}
          valueKey="value"
          options={whiteGloves} />
      </div>
    </SearchForm>
  );
}

export default ClientFilter;



// WEBPACK FOOTER //
// ./src/components/clients/ClientFilter.js